/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, NETWORLD){
	const a = 'is-active';
	const v = 'is-visible';
	const productTop = () => {
		if($('.js-product-top-category').length) {
			const getJSONproduct = (_tag) => {
				return $.getJSON(`/ajax/top/maker/${_tag}.json`);
			};
			for(let i=0; i < $('.js-product-top-category').length; i++) {
				getJSONproduct($('.js-product-top-category').eq(i).find('.rt_cf_m_code').text()).then((data) => {
					console.log(data,'data');
					if(data.rt_bn_maker.length) {
						let addHtml = '';
						for(let l=0; l < data.rt_bn_maker.length; l++) {
							addHtml += '<li class="pure-u-1-5 pure-u-lg-1-2 pure-u-md-1-2 mod-spaceU-child ">'+
							'<a href="'+data.rt_bn_maker[l].rt_cf_m_href.href+'" class="di_block opacity ">'+
							'<figure class="mod-border"><img src="'+data.rt_bn_maker[l].rt_cf_m_image1.src+'" class="width-u-100" alt="'+data.rt_bn_maker[l].rt_cf_m_image1.alt+'"></figure>'+
							'<p class="fw_bold fs_18 fs_md_16 mt10 ">'+data.rt_bn_maker[l].rt_cf_m_name.content[0]+'</p>'+
							'</a>'+
							'</li>';
						}
						$('.js-product-top-category').eq(i).find('.pure-g').append(addHtml);	
					}
				});
			}
		}
	};
	const productDetail = () => {
		if($('.js-product-detail-solution').length) {
			const getJSONsolution = (_tag) => {
				return $.getJSON(`/ajax/products/detail/solution.json${_tag}`);
			};

			// htmlからタグ取得
			let solutionTag = '';
			for(let i = 0; i < $('.rt_cf_keyword_tag_code').length; i++) {
				if(i == 0) {
					solutionTag += '?p_tags='+$('.rt_cf_keyword_tag_code').eq(i).text();
				} else {
					solutionTag += '&p_tags='+$('.rt_cf_keyword_tag_code').eq(i).text();
				}
			}
			// console.log(solutionTag);

			// もっと見るボタンリンク設定
			$('.js-product-detail-solution .mod-button').attr('href', '/solution/'+solutionTag+'');
			
			getJSONsolution(solutionTag).then((data) => {
				// console.log(data.rt_bn_solution_same_keyword,'solution');
				
				// 一件もない場合は要素ごと非表示
				if(!data.rt_bn_solution_same_keyword.length) {
					$('.js-product-detail-solution').addClass('di_none');
				}

				let Html = '';
				for(let i=0; i < data.rt_bn_solution_same_keyword.length; i++) {
					let lead = '';
					if(!data.rt_bn_solution_same_keyword[i].rt_cf_s_explanation) {
						lead = '';
					} else {
						lead = '<p class="mt10">'+data.rt_bn_solution_same_keyword[i].rt_cf_s_explanation.content[0].replaceAll("\n", "<br>").replaceAll("\r", "<br>").replaceAll("\r\n", "<br>")+'</p>';
					}
					let keywordList = '';
					for(let l=0; l < data.rt_bn_solution_same_keyword[i].cf_s_tags.length; l++) {
						if(!(data.rt_bn_solution_same_keyword[i].cf_s_tags[l].rt_cf_s_keyword === null)) {
							keywordList += '<li><span class="mod-label-keyword mod-label-keyword01 opacity">'+data.rt_bn_solution_same_keyword[i].cf_s_tags[l].rt_cf_s_keyword.content+'</span></li>';
						}
					}
					Html += '<li class="pure-u-1-2 pure-u-lg-1-1 pure-u-md-1-1 space-u-60-child">'+
					'<a href="'+data.rt_bn_solution_same_keyword[i].rt_cf_s_href.href+'" class="di_block opacity">'+
					'<div class="mod-box02">'+
					'<div class="pure-g space-u-60">'+
					'<div class="pure-u-1-2 pure-u-lg-1-2 pure-u-md-1-2 space-u-60-child">'+
					'<figure class="di_block pos_relative">'+
					'<img src="'+data.rt_bn_solution_same_keyword[i].rt_cf_s_image.src+'" class="width-u-100" alt="'+data.rt_bn_solution_same_keyword[i].rt_cf_s_image.alt+'">'+
					'</figure>'+
					'</div>'+
					'<div class="pure-u-1-2 pure-u-lg-1-2 pure-u-md-1-2 space-u-60-child">'+
					'<div class="">'+
					'<p class="fw_bold fs_18 fs_md_16 _title">'+data.rt_bn_solution_same_keyword[i].rt_cf_s_title.content[0].replaceAll("\n", "<br>").replaceAll("\r", "<br>").replaceAll("\r\n", "<br>")+'</p>'+
					lead+
					'<div data-view="pc tablet"><div class="pt20"><ul class="mod-labelWrap">'+
					keywordList+
					'</ul></div></div>'+
					'</div>'+
					'</div>'+
					'</div>'+
					'<div data-view="sp"><div class="pt20"><ul class="mod-labelWrap">'+
					keywordList+
					'</ul></div></div>'+
					'</div>'+
					'</a>'+
					'</li>';
				}
				$('.js-product-detail-solution ul').append(Html);
				$('._title').matchHeight();
				$('.mod-box02').matchHeight();
			});
		}
		if($('.js-product-detail-casestudy').length) {
			const getJSONcasestudy = (_tag) => {
				return $.getJSON(`/ajax/products/detail/casestudy.json${_tag}`);
			};

			// htmlからタグ取得
			let casestudyTag = '';
			for(let i = 0; i < $('.rt_cf_keyword_tag_code').length; i++) {
				if(i == 0) {
					casestudyTag += '?p_tags='+$('.rt_cf_keyword_tag_code').eq(i).text();
				} else {
					casestudyTag += '&p_tags='+$('.rt_cf_keyword_tag_code').eq(i).text();
				}
			}
			// console.log(casestudyTag);

			// もっと見るボタンリンク設定
			$('.js-product-detail-casestudy .mod-button').attr('href', '/casestudy/'+casestudyTag+'');
			
			getJSONcasestudy(casestudyTag).then((data) => {
				console.log(data,'casestudy');
				
				// 一件もない場合は要素ごと非表示
				if(!data.rt_bn_casestudy_same_keyword.length) {
					$('.js-product-detail-casestudy').addClass('di_none');
				}

				let Html = '';
				for(let i=0; i < data.rt_bn_casestudy_same_keyword.length; i++) {
					let lead = '';
					if(!data.rt_bn_casestudy_same_keyword[i].rt_cf_c_explanation) {
						lead = '';
					} else {
						lead = '';
						lead = '<p class="color_gray2 mt10 _lead2">'+data.rt_bn_casestudy_same_keyword[i].rt_cf_c_explanation.content[0].replaceAll("\n", "<br>").replaceAll("\r", "<br>").replaceAll("\r\n", "<br>")+'</p>';
					}
					let keywordList = '';
					let companySize = '';
					let industryType = '';
					for(let l=0; l < data.rt_bn_casestudy_same_keyword[i].cf_c_tags.length; l++) {
						if(!(data.rt_bn_casestudy_same_keyword[i].cf_c_tags[l].rt_cf_c_keyword === null)) {
							keywordList += '<li><span class="mod-label-keyword mod-label-keyword01 opacity">'+data.rt_bn_casestudy_same_keyword[i].cf_c_tags[l].rt_cf_c_keyword.content+'</span></li>';
						}
						if(!(data.rt_bn_casestudy_same_keyword[i].cf_c_tags[l].rt_cf_c_company_size === null)) {
							companySize = data.rt_bn_casestudy_same_keyword[i].cf_c_tags[l].rt_cf_c_company_size.content;
						}
						if(!(data.rt_bn_casestudy_same_keyword[i].cf_c_tags[l].rt_cf_c_industry_type === null)) {
							industryType = data.rt_bn_casestudy_same_keyword[i].cf_c_tags[l].rt_cf_c_industry_type.content;
						}
					}
					Html += '<li class="pure-u-1-4 pure-u-md-1-2 space-u-60-child">'+
					'<a href="'+data.rt_bn_casestudy_same_keyword[i].rt_cf_c_href.href+'" class="di_block opacity">'+
					'<figure class="di_block pos_relative">'+
					'<img src="'+data.rt_bn_casestudy_same_keyword[i].rt_cf_c_image.src+'" class="width-u-100" alt="'+data.rt_bn_casestudy_same_keyword[i].rt_cf_c_image.alt+'">'+
					'</figure>'+
					'<p class="mt10">（'+companySize+'）'+industryType+'</p>'+
					'<p class="fw_bold fs_18 fs_md_16 mt5 _title">'+data.rt_bn_casestudy_same_keyword[i].rt_cf_c_name.content[0].replaceAll("\n", "<br>").replaceAll("\r", "<br>").replaceAll("\r\n", "<br>")+'</p>'+
					'<p class="fs_16 fs_md_14 mt5 _lead">'+data.rt_bn_casestudy_same_keyword[i].rt_cf_c_publish_date.content+'</p>'+
					lead+
					'<div class="mod-borderTop pt20 mt10">'+
					'<ul class="mod-labelWrap">'+
					keywordList+
					'</ul>'+
					'</div>'+
					'</a>'+
					'</li>';
				}
				$('.js-product-detail-casestudy ul').append(Html);
				$('._title').matchHeight();
				$('._lead').matchHeight();
				$('._lead2').matchHeight();
			});
		}
	};
	const productDetailLink = () => {
		if($('.js-product-detail-link').length) {
			const getJSONLink = (_code) => {
				return $.getJSON(`/ajax/product/detail/${_code}.json`);
			};
			if($('.js-more-btn_8_20-product').length) {
				let moreBtn = $('.js-more-btn_8_20-product');
				let show = 20; //最初に表示する件数
				let num = 8;  //clickごとに表示したい件数
				let contents = '.js-more-btn_8_20-product-list > li'; // 対象のlist
				let count = 0;
				$(contents + ':nth-child(n + ' + (show + 1) + ')').addClass('di_none').removeClass('_default');

				for(let i=0; i < $('.js-product-detail-link').parent('._default').length; i++) {
					// console.log($('.js-product-detail-link').eq(i).data('id'));
					$('.js-product-detail-link').parent('._default').eq(i).find('.js-product-detail-link').css('pointer-events', 'none');
					getJSONLink($('.js-product-detail-link').parent('._default').eq(i).find('.js-product-detail-link').data('id')).then((data) => {
						// console.log(data.rt_bn_product_detail_list[0]._key);
						let Thishref = $('.js-product-detail-link').parent('._default').eq(i).find('.js-product-detail-link').attr('href').replace('product_detail',data.rt_bn_product_detail_list[0]._key);
						$('.js-product-detail-link').parent('._default').eq(i).find('.js-product-detail-link').attr('href', Thishref.replace('index.html',''));
						$('.js-product-detail-link').parent('._default').eq(i).find('.js-product-detail-link').css('pointer-events', 'auto');
					});
				}
				if($('.js-more-btn_8_20-product-list > li').length < (show+1)) {
					moreBtn.fadeOut();
				}
				moreBtn.on('click', function () {
					count += 1;
					let liClass = ('_show' + String(count));
					console.log(liClass);
					$(contents + '.di_none').slice(0, num).removeClass('di_none').addClass(liClass);
					for(let i=0; i < $('.js-product-detail-link').parent('.'+liClass).length; i++) {
						console.log($('.js-product-detail-link').parent('.'+liClass).eq(i).find('.js-product-detail-link').data('id'));
						$('.js-product-detail-link').parent('.'+liClass).eq(i).find('.js-product-detail-link').css('pointer-events', 'none');
						getJSONLink($('.js-product-detail-link').parent('.'+liClass).eq(i).find('.js-product-detail-link').data('id')).then((data) => {
							// console.log(data.rt_bn_product_detail_list[0]._key);
							let Thishref = $('.js-product-detail-link').parent('.'+liClass).eq(i).find('.js-product-detail-link').attr('href').replace('product_detail',data.rt_bn_product_detail_list[0]._key);
							$('.js-product-detail-link').parent('.'+liClass).eq(i).find('.js-product-detail-link').attr('href', Thishref.replace('index.html',''));
							$('.js-product-detail-link').parent('.'+liClass).eq(i).find('.js-product-detail-link').css('pointer-events', 'auto');
						});
					}
					if ($(contents + '.di_none').length == 0) {
						moreBtn.fadeOut();
					}
				});
			} else {
				for(let i=0; i < $('.js-product-detail-link').length; i++) {
					// console.log($('.js-product-detail-link').eq(i).data('id'));
					$('.js-product-detail-link').eq(i).css('pointer-events', 'none');
					getJSONLink($('.js-product-detail-link').eq(i).data('id')).then((data) => {
						// console.log(data.rt_bn_product_detail_list[0]._key);
						let Thishref = $('.js-product-detail-link').eq(i).attr('href').replace('product_detail',data.rt_bn_product_detail_list[0]._key);
						$('.js-product-detail-link').eq(i).attr('href', Thishref.replace('index.html',''));
						$('.js-product-detail-link').eq(i).css('pointer-events', 'auto');
					});
				}
			}
		}
	};
	const productlabelColor = () => {
		if($('.js-product-label-color').length) {
			let makerName = location.pathname.split('/')[2];
			const getJSONLink = (_maker) => {
				return $.getJSON(`/ajax/product/${_maker}/pro_info/keyword.json`);
			};
			const colorSet = (_categoryname,_color) => {
				for(let i=0; i < $('.js-product-label-color').length; i++) {
					if($('.js-product-label-color').eq(i).data('key') === _categoryname) {
						$('.js-product-label-color').eq(i).addClass(_color);
						$('.js-product-label-color').eq(i).removeClass('di_none');
					}
				}
			};
			getJSONLink(makerName).then((data) => {
				console.log(data.rt_bn_product_tags,'datacolor');
				for(let i=0; i < data.rt_bn_product_tags.length; i++) {
					let num;
					if(!(i < 10)) {
						num = String(i).slice(1);
					} else {
						num = i;
					}
					if(num == 0) {
						// console.log(data.rt_bn_product_tags[i]._key);
						colorSet(data.rt_bn_product_tags[i]._key,'mod-label01');
					} else if(num == 1) {
						// console.log(data.rt_bn_product_tags[i]._key);
						colorSet(data.rt_bn_product_tags[i]._key,'mod-label02');
					} else if(num == 2) {
						// console.log(data.rt_bn_product_tags[i]._key);
						colorSet(data.rt_bn_product_tags[i]._key,'mod-label03');
					} else if(num == 3) {
						// console.log(data.rt_bn_product_tags[i]._key);
						colorSet(data.rt_bn_product_tags[i]._key,'mod-label04');
					} else if(num == 4) {
						// console.log(data.rt_bn_product_tags[i]._key);
						colorSet(data.rt_bn_product_tags[i]._key,'mod-label05');
					} else if(num == 5) {
						// console.log(data.rt_bn_product_tags[i]._key);
						colorSet(data.rt_bn_product_tags[i]._key,'mod-label06');
					} else if(num == 6) {
						// console.log(data.rt_bn_product_tags[i]._key);
						colorSet(data.rt_bn_product_tags[i]._key,'mod-label07');
					} else if(num == 7) {
						// console.log(data.rt_bn_product_tags[i]._key);
						colorSet(data.rt_bn_product_tags[i]._key,'mod-label08');
					} else if(num == 8) {
						// console.log(data.rt_bn_product_tags[i]._key);
						colorSet(data.rt_bn_product_tags[i]._key,'mod-label09');
					} else if(num == 9) {
						// console.log(data.rt_bn_product_tags[i]._key);
						colorSet(data.rt_bn_product_tags[i]._key,'mod-label10');
					}
				}
			});
		}
	};
	productTop();
	productDetail();
	productDetailLink();
	productlabelColor();


})(window.jQuery, window.NETWORLD);
